var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type == "papers" ? "批量发起任务作业" : "发起任务作业",
        visible: _vm.dialogVisible,
        width: "800px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _vm.data.id
        ? _c("div", { staticClass: "paper-info" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", [_vm._v("试卷名称：" + _vm._s(_vm.details.name))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", [
                _vm._v("题量：" + _vm._s(_vm.details.questionNumber))
              ]),
              _vm._v(" "),
              _vm.details.questionTypeNumber &&
              _vm.details.questionTypeNumber.length > 0
                ? _c(
                    "span",
                    [
                      _vm._v("\n        （ "),
                      _vm._l(_vm.details.questionTypeNumber, function(item) {
                        return _c(
                          "small",
                          { key: item.questionType, staticClass: "items" },
                          [
                            _c("small", [
                              _vm._v(
                                _vm._s(item.questionTypeTag) +
                                  _vm._s(item.number)
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" ）\n      ")
                    ],
                    2
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "95px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "任务类型：", prop: "resourceLibType" } },
            [
              _c("div", { staticClass: "modes" }, [
                _c(
                  "div",
                  {
                    staticClass: "mode-item",
                    class: { active: _vm.form.resourceLibType == 10 },
                    on: {
                      click: function($event) {
                        _vm.form.resourceLibType = 10
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "iconfont icon-shangkexunlian" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("训练")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "mode-item",
                    class: { active: _vm.form.resourceLibType == 20 },
                    staticStyle: { "margin-top": "-4px" },
                    on: {
                      click: function($event) {
                        _vm.form.resourceLibType = 20
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "iconfont icon-ceyan",
                      staticStyle: { "font-size": "24px" }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("测验")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "mode-item",
                    class: { active: _vm.form.resourceLibType == 30 },
                    on: {
                      click: function($event) {
                        _vm.form.resourceLibType = 30
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "iconfont icon-kaoshi" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考试")])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.type == "paper"
            ? _c(
                "el-form-item",
                { attrs: { label: "任务名称：", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { autocomplete: "off", placeholder: "请输入" },
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              )
            : _vm.type == "papers"
            ? _c("el-form-item", { attrs: { label: "已选试卷：" } }, [
                _c("span", [_vm._v("共 " + _vm._s(_vm.data.length) + " 张")])
              ])
            : _vm.type == "select"
            ? _c(
                "el-form-item",
                { attrs: { label: "我的题库：", prop: "testPaperId" } },
                [
                  _c("paper-list", {
                    attrs: { clearable: false, multiple: "" },
                    on: { change: _vm.paperChange },
                    model: {
                      value: _vm.form.testPaperId,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "testPaperId", $$v)
                      },
                      expression: "form.testPaperId"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "ml-10 color-999" },
                    [
                      _vm._v("\n        注：如无试卷，请至"),
                      _c(
                        "el-link",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            margin: "-1px 1px 0"
                          },
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                path: "/resource/papers"
                              })
                            }
                          }
                        },
                        [_vm._v("我的题库")]
                      ),
                      _vm._v("中添加\n      ")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "发起对象：", prop: "clazzIds" } },
            [
              _c("clazz-list", {
                attrs: { clearable: true, multiple: true },
                model: {
                  value: _vm.form.clazzIds,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "clazzIds", $$v)
                  },
                  expression: "form.clazzIds"
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ml-10 color-999" }, [
                _vm._v("注：选择需要发起的班级")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.resourceLibType == 20 || _vm.form.resourceLibType == 30
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "合格分数：", prop: "passScore" } },
                  [
                    _c("el-input-number", {
                      attrs: { size: "mini", precision: 0 },
                      model: {
                        value: _vm.form.passScore,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "passScore", $$v)
                        },
                        expression: "form.passScore"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label:
                        _vm.func.learnType(_vm.form.resourceLibType) + "时长：",
                      prop: "duration"
                    }
                  },
                  [
                    _c("el-input-number", {
                      attrs: {
                        size: "mini",
                        min: 1,
                        max: 360,
                        step: 5,
                        precision: 0
                      },
                      model: {
                        value: _vm.form.duration,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "duration", $$v)
                        },
                        expression: "form.duration"
                      }
                    }),
                    _c("span", { staticClass: "ml-5" }, [_vm._v("分钟")])
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.form.resourceLibType == 10 || _vm.form.resourceLibType == 20
            ? _c(
                "el-form-item",
                { attrs: { label: "有效期：", prop: "endTimeSpan" } },
                [
                  _c("el-input-number", {
                    attrs: { size: "mini", min: 1, step: 0.5 },
                    model: {
                      value: _vm.form.endTimeSpan,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "endTimeSpan", $$v)
                      },
                      expression: "form.endTimeSpan"
                    }
                  }),
                  _c("span", { staticClass: "ml-5" }, [_vm._v("小时")])
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "item-list type-des" },
        [
          _vm.form.resourceLibType == 10
            ? [
                _c("li", [
                  _c("div", { staticClass: "keys" }, [
                    _vm._v("训练任务规则：")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "values" }, [
                    _c("p", [
                      _vm._v(
                        "将试卷的题自动分为5题一关，训练者每关全对才能继续下一关，直到最后全部过关。错题重复，适合强化内容，建议100题以内的作业。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("注：训练任务中"),
                      _c("span", { staticClass: "color-red" }, [
                        _vm._v("仅包含单选、多选、判断、排序相关题型")
                      ]),
                      _vm._v("，其他题目将不会被加入。")
                    ])
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.form.resourceLibType == 20
            ? [
                _c("li", [
                  _c("div", { staticClass: "keys" }, [
                    _vm._v("测验任务规则：")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "values" }, [
                    _vm._v(
                      "与驾照考试模式相同，测验者每做一题系统立即反馈对错及答案，全部做完后出测验结果测验任务规则:错题不重复做，适合检查学习情况，建议100题以内的作业。"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("div", { staticClass: "keys" }, [_vm._v("设定时长：")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "values" }, [
                    _vm._v(
                      "为完成测验的时长，以测验者开始测验的时间为开始时间。任务发起后，测验者即可进入测验。"
                    )
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.form.resourceLibType == 30
            ? [
                _c("li", [
                  _c("div", { staticClass: "keys" }, [
                    _vm._v("考试任务规则：")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "values" }, [
                    _vm._v(
                      "与线下考试模式相同，考试者做错系统不提示，考试者在考试时间结束后不能再答，系统在考试结全部结束后出考试结果。适合考核学生成绩，建议100题以内的作业。"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("div", { staticClass: "keys" }, [_vm._v("设定时长：")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "values" }, [
                    _vm._v("为考试的时长，以教师发起时间为考试开始时间。")
                  ])
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { type: "primary", disabled: _vm.loading },
              on: { click: _vm.confirm }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30b16471", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b16471","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/components/shared/LaunchTask.vue
// module id = 593
// module chunks = 14